import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { Oauth2Settings, SecureTabs } from '../../../components';
import { ToDashboardError } from '../../../components/ui';
import { useCurrentProject } from '../../../contexts/settings';

type RouteParams = { projectId: string; merchantId: string };

const OauthSettings = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { error } = useCurrentProject(projectId);

  if (error) {
    return <ToDashboardError error={error} pageName="oauth-settings_open" />;
  }

  return (
    <SecureTabs>
      <Oauth2Settings projectId={projectId} />
    </SecureTabs>
  );
};

export default withRouter(OauthSettings);
